module.exports = __webpack_public_path__ + "img/snt.c3dbc295.svg";